"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var MoreTableData = function MoreTableData(_ref) {
  var tableData = _ref.tableData;
  // const[record,setRecord]=useState({});
  // useEffect(async()=>{
  //   setRecord(tableData);   
  // },[tableData]);
  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [tableData]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 11,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Date Of Birth",
    text: "center",
    span: 1
  }, tableData.DOB ? tableData.DOB : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "School Type",
    span: 2
  }, tableData.school_type ? tableData.school_type : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Math WS",
    span: 2
  }, tableData.Worksheet_no ? tableData.Worksheet_no : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Math Label",
    span: 2
  }, tableData.Label ? tableData.Label : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "English WS",
    span: 2
  }, tableData.English_worksheet_no ? tableData.English_worksheet_no : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "English Label",
    span: 2
  }, tableData.English_label ? tableData.English_label : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "CL code",
    span: 2
  }, tableData.CL_code ? tableData.CL_code : "No Data")))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 11,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Class",
    text: "center",
    span: 1
  }, tableData.Class ? tableData.Class : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Subject",
    text: "center",
    span: 1
  }, tableData.Subject ? tableData.Subject : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Mother Name",
    text: "center",
    span: 2
  }, tableData.Mother_name ? tableData.Mother_name : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "School Fee",
    span: 2
  }, tableData.School_fee ? tableData.School_fee : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Comment/Reason",
    span: 2
  }, tableData.comment ? tableData.comment : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Address",
    span: 2
  }, tableData.Address ? tableData.Address : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 200
    },
    contentStyle: {
      'width': 200
    },
    label: "Calling no",
    span: 2
  }, tableData.Calling_no ? tableData.Calling_no : "No Data"))))))));
};

var _default = MoreTableData;
exports.default = _default;